import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addContactType, getContactType, updateContactType, deleteContactType } from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class ContactType extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contacttype: ''
        }
        this.handleContactTypeSubmit = this.handleContactTypeSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (contacttype) => {
        this.setState({ contacttype: contacttype });
        this.setState({ deleteModal: true });
    };

    handleDeleteContactType = () => {
        const { onDeleteContactType } = this.props;
        const { contacttype } = this.state;

        if (contacttype.id !== undefined) {
            onDeleteContactType(contacttype);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleContactTypeSubmit(value) {
        this.props.addContactType(value, this.props.history);
    }

    componentDidMount() {
        const { onGetContactType } = this.props;
        onGetContactType(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { contacttypes } = this.props;
        if (!isEmpty(contacttypes) && size(prevProps.contacttypes) !== size(contacttypes)) {
            this.setState({ contacttypes: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ contacttype: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const contacttype = arg;
        this.setState({
            contacttype: {
                id: contacttype.id,
                contactTypeId: contacttype.contactTypeId,
                contactTypeTitle: contacttype.contactTypeTitle,
                agentId: contacttype.agentId
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { contacttypes, onUpdateAppContactType } = this.props;
        const { isEdit, deleteModal } = this.state;
        const contacttype = this.state.contacttype;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteContactType}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Contact Type")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        contactTypeTitle: (this.state && this.state.contactTypeTitle) || "",

                                    }}
                                    validationSchema={Yup.object().shape({
                                        contactTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleContactTypeSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">Contact Type</h5>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="contactTypeTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="contactTypeTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.contactTypeTitle && touched.contactTypeTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="contactTypeTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="contactTypeTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(contacttypes, (contacttype, typekey) => (
                                                                    <tr key={"_list_" + typekey}>
                                                                        <th>{typekey + 1}</th>
                                                                        <td>{contacttype.contactTypeTitle}</td>
                                                                      <td>
                                                                        {contacttype.agentId > 0 ? (
                                                                            <>
                                                                            <ActionEdit onClick={() => this.toggleRightCanvas(contacttype)} />
                                                                            <ActionDelete onClick={() => this.onClickDelete(contacttype)} />
                                                                            </>
                                                                        ) : null}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: contacttype.id,
                                        contactTypeId: contacttype.contactTypeId,
                                        contactTypeTitle: contacttype.contactTypeTitle,
                                        agentId: contacttype.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        contactTypeTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                contactTypeId: values.contactTypeId,
                                                contactTypeTitle: values.contactTypeTitle,
                                                agentId: values.agentId
                                            };
                                            onUpdateAppContactType(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="contactTypeTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="contactTypeTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.contactTypeTitle && touched.contactTypeTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="contactTypeTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="contactTypeTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
ContactType.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addContactType: PropTypes.func,
    onGetContactType: PropTypes.func,
    contacttypes: PropTypes.array,
    onDeleteContactType: PropTypes.func,
    onUpdateAppContactType: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        contacttypes: AppoinmentObject.contacttypes,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addContactType: (data) => dispatch(addContactType(data)),
    onGetContactType: (agentId) => dispatch(getContactType(agentId)),
    onDeleteContactType: (id) => dispatch(deleteContactType(id)),
    onUpdateAppContactType: (data) => dispatch(updateContactType(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactType))
